// CSS import order matters:
// 1. Tailwind + scanned sources (./tailwind.css) + token bridge from @portals-platform/ui
// 2. Form control styles, which build on the utilities above
// 3. Brand theme overrides (this brand's actual token values)
import './tailwind.css';
import '@portals-platform/ui-forms/forms.css';
import './theme.css';

import { bootstrap } from '@portals-platform/app-core-certificate-portal';
import { brinksConfig } from './brand.config.js';

async function main() {
  if (import.meta.env.DEV && import.meta.env.VITE_MSW === 'true') {
    const { worker } = await import('./mocks/browser.js');
    await worker.start({ onUnhandledRequest: 'warn' });
  }
  bootstrap(brinksConfig);
}

main();
